// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-widget {
  padding: 16px;
  overflow-y: auto !important;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.license-widget::-webkit-scrollbar {
  width: 8px;
}
.license-widget::-webkit-scrollbar-track {
  background: transparent;
}
.license-widget::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.license-widget.trial {
  background-color: rgba(25, 118, 210, 0.1);
}
.license-widget.expired {
  background-color: rgba(211, 47, 47, 0.1);
}
.license-widget.valid {
  background-color: rgba(76, 175, 80, 0.1);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
}
.loading-container p {
  margin: 0;
  color: var(--text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 0.9rem;
}

.license-container {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.license-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.license-header h2 {
  margin: 0 0 0 8px;
  font-size: 1.3rem;
  font-weight: 500;
}
.license-header .valid-icon {
  color: #4caf50;
  font-size: 24px;
  height: 24px;
  width: 24px;
}
.license-header .trial-icon {
  color: #1976d2;
  font-size: 24px;
  height: 24px;
  width: 24px;
}
.license-header .expired-icon {
  color: #d32f2f;
  font-size: 24px;
  height: 24px;
  width: 24px;
}

.message-container {
  flex: 1;
  margin-bottom: 16px;
}
.message-container p {
  margin: 0 0 16px 0;
  font-size: 1rem;
  line-height: 1.5;
}

.progress-container {
  margin-top: 16px;
}

.license-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.license-form .full-width {
  width: 100%;
}
.license-form mat-form-field {
  margin-bottom: 0;
}
.license-form .form-error {
  color: #d32f2f;
  font-size: 0.85rem;
  margin-bottom: 8px;
  padding: 8px 12px;
  background: rgba(211, 47, 47, 0.1);
  border-radius: 4px;
}
.license-form .button-row {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}
.license-form .button-row button mat-spinner {
  display: inline-block;
  margin-right: 8px;
}
.license-form .button-row button mat-spinner ::ng-deep circle {
  stroke: white;
}
.license-form .button-row .purchase-button {
  background-color: #1976d2 !important;
  color: white !important;
}
.license-form .button-row .purchase-button:hover {
  background-color: #1565c0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/license-widget/license-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EAGA,qBAAA;EACA,qDAAA;AADF;AAGE;EACE,UAAA;AADJ;AAIE;EACE,uBAAA;AAFJ;AAKE;EACE,oCAAA;EACA,kBAAA;AAHJ;AAME;EACE,yCAAA;AAJJ;AAOE;EACE,wCAAA;AALJ;AAQE;EACE,wCAAA;AANJ;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;AAPF;AASE;EACE,SAAA;EACA,gDAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AARF;AAUE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AARJ;AAWE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AATJ;AAYE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAVJ;AAaE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAXJ;;AAeA;EACE,OAAA;EACA,mBAAA;AAZF;AAcE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAZJ;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAbF;AAeE;EACE,WAAA;AAbJ;AAgBE;EACE,gBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAhBJ;AAmBM;EACE,qBAAA;EACA,iBAAA;AAjBR;AAmBQ;EACE,aAAA;AAjBV;AAsBI;EACE,oCAAA;EACA,uBAAA;AApBN;AAsBM;EACE,oCAAA;AApBR","sourcesContent":[".license-widget {\n  padding: 16px;\n  overflow-y: auto !important;\n  overflow-x: hidden;\n\n  // Scrollbar styling\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n  }\n\n  &.trial {\n    background-color: rgba(25, 118, 210, 0.1); // Light blue for trial\n  }\n\n  &.expired {\n    background-color: rgba(211, 47, 47, 0.1); // Light red for expired\n  }\n\n  &.valid {\n    background-color: rgba(76, 175, 80, 0.1); // Light green for valid license\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n\n  p {\n    margin: 0;\n    color: var(--text-secondary, rgba(0, 0, 0, 0.6));\n    font-size: 0.9rem;\n  }\n}\n\n.license-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n.license-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  \n  h2 {\n    margin: 0 0 0 8px;\n    font-size: 1.3rem;\n    font-weight: 500;\n  }\n  \n  .valid-icon {\n    color: #4caf50; // Green\n    font-size: 24px;\n    height: 24px;\n    width: 24px;\n  }\n  \n  .trial-icon {\n    color: #1976d2; // Blue\n    font-size: 24px;\n    height: 24px;\n    width: 24px;\n  }\n  \n  .expired-icon {\n    color: #d32f2f; // Red\n    font-size: 24px;\n    height: 24px;\n    width: 24px;\n  }\n}\n\n.message-container {\n  flex: 1;\n  margin-bottom: 16px;\n  \n  p {\n    margin: 0 0 16px 0;\n    font-size: 1rem;\n    line-height: 1.5;\n  }\n}\n\n.progress-container {\n  margin-top: 16px;\n}\n\n.license-form {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  .full-width {\n    width: 100%;\n  }\n\n  mat-form-field {\n    margin-bottom: 0;\n  }\n\n  .form-error {\n    color: #d32f2f;\n    font-size: 0.85rem;\n    margin-bottom: 8px;\n    padding: 8px 12px;\n    background: rgba(211, 47, 47, 0.1);\n    border-radius: 4px;\n  }\n\n  .button-row {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 8px;\n\n    button {\n      mat-spinner {\n        display: inline-block;\n        margin-right: 8px;\n\n        ::ng-deep circle {\n          stroke: white;\n        }\n      }\n    }\n\n    .purchase-button {\n      background-color: #1976d2 !important;\n      color: white !important;\n\n      &:hover {\n        background-color: #1565c0 !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
